/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Suspended_ContactInputs */



/**
* | output |
* | --- |
* | "Please contact your administrator to find out more." |
*
* @param {Org_Suspended_ContactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_suspended_contact = /** @type {((inputs?: Org_Suspended_ContactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Suspended_ContactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wenden Sie sich an Ihre Administratorin oder Ihren Administrator.")
	return /** @type {LocalizedString} */ ("Please contact your administrator to find out more.")
});